import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from './ui/dialog';
import { Tabs, TabsContent, TabsList, TabsTrigger } from './ui/tabs';
import { Chrome } from 'lucide-react';

const AuthModal = ({ open, onOpenChange }) => {
  const { signInWithGoogle } = useAuth();
  const [loading, setLoading] = useState(false);
  // Google-only auth modal.
  // (We avoid requesting Gmail/Calendar/Contacts scopes anywhere in the frontend.)
  const handleGoogleSignIn = async () => {
    setLoading(true);
    try {
      await signInWithGoogle();
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="text-2xl font-bold text-center">Welcome to Fig Careers</DialogTitle>
          <DialogDescription className="text-center">
            Sign in to save your career roadmaps and access them anytime
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4">
          <Button
            type="button"
            className="w-full bg-accent hover:bg-accent-hover"
            onClick={handleGoogleSignIn}
            disabled={loading}
          >
            <Chrome className="mr-2 h-4 w-4" />
            {loading ? 'Redirecting...' : 'Continue with Google'}
          </Button>
          <p className="text-xs text-center text-muted-foreground">
            By signing in, you agree to our{' '}
            <a
              href="/privacypolicy.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="underline hover:text-foreground"
            >
              Privacy Policy
            </a>
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default AuthModal;
